import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createActionGroup, createFeature, createReducer, createSelector, on, props } from '@ngrx/store';

// The boeke editor keeps its data in its own lazy feature store, keyed by
// version id; this small feature only holds the boekes (keyed by boeke id)
// whose name a breadcrumb needs to select by id.
export const NAME = 'boekes';

export interface BoekeNameInterface {
  id: number;
  name?: string;
}

export type State = EntityState<BoekeNameInterface>;

export const adapter: EntityAdapter<BoekeNameInterface> = createEntityAdapter<BoekeNameInterface>();

export const initialState: State = adapter.getInitialState();

export const actions = createActionGroup({
  source: 'Boekes',
  events: {
    'Upsert Boekes': props<{ boekes: BoekeNameInterface[] }>(),
  },
});

export const feature = createFeature({
  name: NAME,
  reducer: createReducer(
    initialState,
    on(actions.upsertBoekes, (state, { boekes }): State => adapter.upsertMany(boekes, state))
  ),
});

/**
 * Null-safe name lookup: returns an empty string while the boeke
 * is not (yet) in the store, so route data (breadcrumbs) can't crash on it.
 *
 * Standalone props-selector: `createFeature`'s `extraSelectors` only accepts
 * single-argument selectors or selector factories.
 */
export const selectName = createSelector(
  feature.selectEntities,
  (entities, byId: { id: number }): string => entities[byId.id]?.name ?? ''
);
